module.exports = __webpack_public_path__ + "static/nail-salons-hero-ca1331614d6232e2f842011a426aadb0.png";